import React, { useEffect, useRef } from "react";
import styles from "./PufferySection.module.css";
import djImg from "../../assets/DimoraImages/IMG_9736.jpg";

import { PUFFERY_SECTION_CONTENT } from "../../Constants";

const PufferySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll("[data-animate]");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={styles.section}>

      {/* ========== TOP CONTENT ========== */}
      <div
        data-animate
        className={`${styles.container} ${styles.animate} ${styles.fadeUp}`}
      >
        <div className={styles.left}>
          <h1 className={styles.heading}>
            {PUFFERY_SECTION_CONTENT.headingLine1}{" "}
            <span>{PUFFERY_SECTION_CONTENT.headingHighlight}</span>
            {/* <br /> */} <span> </span>
            {PUFFERY_SECTION_CONTENT.headingLine2}
          </h1>

          <p className={styles.desc}>
            {PUFFERY_SECTION_CONTENT.descriptionPart1}
            <br /><br />
            {PUFFERY_SECTION_CONTENT.descriptionPart2}
          </p>
        </div>

        <div
          className={`${styles.right} ${styles.animate} ${styles.fadeRight} ${styles.delay1}`}
          data-animate
        >
          <img src={djImg} alt="dj" />
        </div>
      </div>

      {/* ========== SAY SECTION ========== */}
      <div
        data-animate
        className={`${styles.sayWrapper} ${styles.animate} ${styles.fadeUp}`}
      >
        <section className={styles.saySection}>
          <div className={styles.sayImage}>
            <img
              src="https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/imps/Studio%20Shoot2010%20(1).jpg"
              alt="testimonial"
            />

            <div
              className={`${styles.quoteCard} ${styles.animate} ${styles.scaleFade} ${styles.delay2}`}
              data-animate
            >
              <p>{PUFFERY_SECTION_CONTENT.founderQuote}</p>
              <h4>{PUFFERY_SECTION_CONTENT.founderName}</h4>
              <span>{PUFFERY_SECTION_CONTENT.founderRole}</span>
            </div>
          </div>

          <div
            className={`${styles.sayContent} ${styles.animate} ${styles.fadeLeft} ${styles.delay1}`}
            data-animate
          >
            <h2>{PUFFERY_SECTION_CONTENT.meetHeading}</h2>

            {PUFFERY_SECTION_CONTENT.meetParagraphs.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
};

export default PufferySection;